export function isCurrentUser(email?: string, username?: string): boolean {
  if (!email || !username) {
    return false;
  }

  return email.toUpperCase() === username.toUpperCase();
}
